var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNuclear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.4316C15.8284 16.4316 16.5 15.7601 16.5 14.9316C16.5 14.1032 15.8284 13.4316 15 13.4316C14.1716 13.4316 13.5 14.1032 13.5 14.9316C13.5 15.7601 14.1716 16.4316 15 16.4316Z",
    fill: "url(#paint0_linear_2146_13167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM15 28.6364C7.5 28.6364 1.36364 22.5 1.36364 15C1.36364 7.5 7.5 1.36364 15 1.36364C22.5 1.36364 28.6364 7.5 28.6364 15C28.6364 22.5 22.5 28.6364 15 28.6364Z",
    fill: "url(#paint1_linear_2146_13167)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.659 18.2051C17.5909 18.0687 17.3863 17.9324 17.2499 17.8642C17.0454 17.796 16.909 17.8642 16.7045 17.9324C16.159 18.2733 15.6136 18.4096 14.9999 18.4096C14.5909 18.4096 14.3181 18.6824 14.3181 19.0915C14.3181 19.5005 14.5909 19.7733 14.9999 19.7733C15.6136 19.7733 16.2272 19.6369 16.7727 19.4324L19.8409 24.7505C16.8409 26.2505 13.159 26.2505 10.159 24.7505L13.5681 18.8869C13.7727 18.546 13.6363 18.1369 13.2954 17.9324C12.9545 17.7278 12.5454 17.8642 12.3409 18.2051L8.59086 24.6824C8.38631 25.0233 8.52267 25.4324 8.86358 25.6369C10.7045 26.7278 12.8181 27.2733 14.9999 27.2733C17.1818 27.2733 19.2954 26.7278 21.1363 25.6369C21.4772 25.4324 21.5454 25.0233 21.409 24.6824L17.659 18.2051Z",
    fill: "url(#paint2_linear_2146_13167)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6364 8.86368C24.5455 7.02277 22.9773 5.45459 21.1364 4.36368C20.7955 4.15914 20.3864 4.2955 20.1818 4.63641L16.4318 11.1137C16.3636 11.25 16.3636 11.4546 16.3636 11.6591C16.4318 11.8637 16.5 12 16.7046 12.0682C17.25 12.341 17.6591 12.75 17.9318 13.2955C18.1364 13.6364 18.5455 13.7046 18.8864 13.5682C19.2273 13.3637 19.2955 12.9546 19.1591 12.6137C18.8864 12.0682 18.4773 11.591 18 11.25L21.0682 5.93186C22.4318 6.88641 23.6591 8.11368 24.4773 9.5455C25.2955 10.9773 25.8409 12.6137 25.9091 14.3182H19.0909C18.6818 14.3182 18.4091 14.591 18.4091 15C18.4091 15.4091 18.6818 15.6819 19.0909 15.6819H26.5909C27 15.6819 27.2727 15.4091 27.2727 15C27.2727 12.8864 26.7273 10.7046 25.6364 8.86368Z",
    fill: "url(#paint3_linear_2146_13167)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3864 15.4783C11.5227 15.3419 11.5909 15.2056 11.5909 15.001C11.5909 14.3874 11.7273 13.8419 12.0682 13.2965C12.2727 12.9556 12.1364 12.5465 11.7955 12.3419C11.4546 12.1374 11.0455 12.2738 10.8409 12.6147C10.5682 13.1601 10.3637 13.7056 10.2273 14.3192H4.09093C4.22729 12.6147 4.70457 10.9783 5.52275 9.54649C6.34093 8.11467 7.5682 6.81922 8.93184 5.93286L12.3409 11.7965C12.5455 12.1374 12.9546 12.2056 13.2955 12.0692C13.6364 11.8647 13.7046 11.4556 13.5682 11.1147L9.8182 4.6374C9.61366 4.29649 9.20457 4.22831 8.86366 4.36467C7.02275 5.45558 5.45457 7.02377 4.36366 8.86467C3.27275 10.7056 2.72729 12.8874 2.72729 15.001C2.72729 15.4101 3.00002 15.6829 3.40911 15.6829H10.9091C11.1137 15.6829 11.25 15.6147 11.3864 15.4783Z",
    fill: "url(#paint4_linear_2146_13167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13167",
    x1: 15,
    y1: 13.4316,
    x2: 15,
    y2: 16.4316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_13167",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_13167",
    x1: 14.9848,
    y1: 17.8359,
    x2: 14.9848,
    y2: 27.2733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2146_13167",
    x1: 21.8182,
    y1: 4.26758,
    x2: 21.8182,
    y2: 15.6819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2146_13167",
    x1: 8.18067,
    y1: 4.29883,
    x2: 8.18067,
    y2: 15.6829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuclear);
export default __webpack_public_path__ + "static/media/nuclear.b2420a91.svg";
export { ForwardRef as ReactComponent };